angular.module('zc.commonApi')

.factory 'ProjectExcludeIp', ($resource, $q, BaseProjectCrudService) ->
  class ProjectExcludeIp extends BaseProjectCrudService

  new ProjectExcludeIp(
    $resource
    $q
    '/api/projects/:projectId/exclude_ips/:id'
    'exclude_ip'
    'exclude_ips'
  )




// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/exclude_ips.service.coffee